import React, { useState } from "react";
import { api_post } from "../../../helpers";
import Swal from "sweetalert2";

const AddSpinAcquisition = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    eligible_credit_from: "",
    eligible_credit_to: "",
    eligible_spin: "",
    tier_sequence: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.eligible_credit_from) newErrors.eligible_credit_from = "Eligible credit from is required";
    if (!formData.eligible_credit_to) newErrors.eligible_credit_to = "Eligible credit to is required";
    if (!formData.eligible_spin) newErrors.eligible_spin = "Eligible spin is required";
    if (!formData.tier_sequence) newErrors.tier_sequence = "Tier sequence is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    try {
      const response = await api_post("spinwheel/spin/acquisition/create", formData);
      if (response.status === 1) {
        Swal.fire(
          'Success!',
          'Acquisition tier created successfully!',
          'success'
        ).then(() => {
          setFormData({
            name: "",
            eligible_credit_from: "",
            eligible_credit_to: "",
            eligible_spin: "",
            tier_sequence: "",
          });
          onSuccess();
          // Close modal
          document.querySelector('[data-bs-dismiss="modal"]').click();
          // Refresh the page after successful creation
          window.location.reload();
        });
      } else {
        Swal.fire(
          'Error!',
          'Failed to create acquisition tier.',
          'error'
        );
      }
    } catch (error) {
      console.error("Error creating acquisition tier:", error);
      Swal.fire(
        'Error!',
        'An error occurred while creating the acquisition tier.',
        'error'
      );
    }
  };

  return (
    <div className="modal fade" id="add-spin-acquisition">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add New Acquisition Tier</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <div className="text-danger">{errors.name}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">Eligible Credit From</label>
                <input
                  type="number"
                  className="form-control"
                  name="eligible_credit_from"
                  value={formData.eligible_credit_from}
                  onChange={handleChange}
                />
                {errors.eligible_credit_from && <div className="text-danger">{errors.eligible_credit_from}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">Eligible Credit To</label>
                <input
                  type="number"
                  className="form-control"
                  name="eligible_credit_to"
                  value={formData.eligible_credit_to}
                  onChange={handleChange}
                />
                {errors.eligible_credit_to && <div className="text-danger">{errors.eligible_credit_to}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">Eligible Spins</label>
                <input
                  type="number"
                  className="form-control"
                  name="eligible_spin"
                  value={formData.eligible_spin}
                  onChange={handleChange}
                />
                {errors.eligible_spin && <div className="text-danger">{errors.eligible_spin}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">Tier Sequence</label>
                <input
                  type="number"
                  className="form-control"
                  name="tier_sequence"
                  value={formData.tier_sequence}
                  onChange={handleChange}
                />
                {errors.tier_sequence && <div className="text-danger">{errors.tier_sequence}</div>}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Add Acquisition Tier
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSpinAcquisition; 